<template>
  <div class="Footer">
    <div class="footer-content">
      <div class="left">
        <div class="title">斯拓课堂</div>
        <div class="title">服务热线:027-87688455</div>
        <div class="p">斯拓教育（武汉总部）: 武汉东湖开发区关山大道茅店山东路2号3号楼 (武汉华夏理工学院旁)</div>
        <div class="p">
          Copyright©
          <a href="https://beian.miit.gov.cn/">鄂ICP备17010279号-5</a>
          湖北斯拓教育发展研究院&amp;版权所有
        </div>
      </div>
      <div class="right">
        <div class="image">
          <img
            class="img"
            :src="require('@/assets/images/icons/public1.jpg')"
          />
          <div class="p">微信公众号</div>
        </div>
        <div class="image">
          <img
            class="img"
            :src="require('@/assets/images/icons/public2.jpg')"
          />
          <div class="p">微信公众号</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
  components: {},
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>
<style scoped lang="scss">
.Footer {
  width: 100%;
  min-height: 178px;
  background: #24252a;
  .footer-content {
    @include w1200;
    @include flex;
    padding: 30px;
    .left {
      flex: 1;
      .title {
        color: #e0e0e0;
        font-size: 20px;
      }
      .p {
        font-size: 12px;
        color: #a1a4b3;
      }
    }
    .right {
      width: 200px;
      padding-top: 20px;
      @include flex;
      .image {
        width: 85px;
        text-align: center;
        .img {
          width: 100%;
          height: 85px;
          margin-bottom: 5px;
        }
        .p {
          font-size: 12px;
          color: #a1a4b3;
        }
      }
    }
  }
}
</style>
